const AppLoading = () => <div>Loading...</div>;

export { AppLoading };
